<template>
  <div>
    <Modal :title="title" v-model="bindModal" @on-cancel="$refs.bindForm.resetFields()" width="750" :mask-closable="false">
      <Spin fix v-if="floatingIpGetting || serverGetting"></Spin>
      <Alert type="error" v-else-if="error">获取列表数据失败！</Alert>
      <Form :model="bindForm" ref="bindForm" v-else :rules="bindFormRule">
        <Alert show-icon>将一个指定实例的端口关联到浮动IP.</Alert>
        <Alert show-icon type="error" v-if="errorMsgShow">{{ errorMsg }}</Alert>
        <FormItem label="浮动IP" prop="floatingip_id">
          <Select v-model="bindForm.floatingip_id" :disabled="!floatingIpCanChange">
            <Option v-for="item in floatingIpList" :key="item.id" :value="item.id" v-if="item.status === 'DOWN' && item.fixed_ip_address === ''">{{ item.floating_ip_address }}</Option>
          </Select>
        </FormItem>
        <FormItem label="实例" prop="server">
          <Select v-model="bindForm.server" @on-change="getPortList" :disabled="!serverCanChange" placeholder="请选择要绑定的实例" filterable>
            <Option v-for="item in serverList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="端口" prop="port_id">
          <Select v-model="bindForm.port_id" @on-change="getFixedIpList" placeholder="请选择要绑定的端口" not-found-text="请选择绑定端口的实例">
            <Option v-for="item in portList" :key="item.id" :value="item.id">
              {{ item.name ? item.name : '(' + item.id.substr(0, 10) + ')' }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="端口IP地址" prop="fixed_ip_address">
          <Select v-model="bindForm.fixed_ip_address" placeholder="" not-found-text="请选择拥有IP地址的端口">
            <Option v-for="item in fixedIpList" :key="item.ip_address" :value="item.ip_address">{{ item.ip_address }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="bindModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getPrivateCloudAllFloatingIp, changePrivateCloudFloatingIp } from '@/api/private-cloud/floating-ip'
import { getPrivateCloudAllServer } from '@/api/private-cloud/server'
import { getPrivateCloudAllPort, detailPrivateCloudPort } from '@/api/private-cloud/port'

export default {
  name: 'server-bind-floating-ip',
  data () {
    return {
      title: '关联浮动IP',
      bindModal: false,
      bindForm: {
        floatingip_id: '',
        server: '',
        port_id: '',
        fixed_ip_address: ''
      },
      bindFormRule: {
        floatingip_id: [
          { required: true, message: '请选择浮动IP', trigger: 'change' }
        ],
        server: [
          { required: true, message: '请选择实例', trigger: 'change' }
        ],
        port_id: [
          { required: true, message: '请选择端口', trigger: 'change' }
        ],
        fixed_ip_address: [
          { required: true, message: '请选择端口IP地址', trigger: 'change' }
        ]
      },
      floatingIpList: [],
      portList: [],
      serverList: [],
      fixedIpList: [],
      floatingIpCanChange: true,
      serverCanChange: true,
      error: false,
      submitting: false,
      errorMsgShow: false,
      errorMsg: '',
      floatingIpGetting: false,
      serverGetting: false
    }
  },
  methods: {
    // 打开
    openModal (id, type) {
      this.bindForm = {
        floatingip_id: '',
        server: '',
        port_id: '',
        fixed_ip_address: ''
      }
      this.error = false
      this.bindModal = true
      if (type === 'floating_ip') {
        this.getFloatingIpList(id)
        this.getServerList()
      } else if (type === 'server') {
        this.getServerList(id)
        this.getFloatingIpList()
      } else {
        this.getServerList()
        this.getFloatingIpList()
      }
    },
    // 获取浮动IP列表
    getFloatingIpList (id) {
      this.floatingIpGetting = true
      getPrivateCloudAllFloatingIp().then(res => {
        this.floatingIpList = res.data
        if (id) {
          let have = false
          this.bindForm.floatingip_id = id
          for (let i in this.floatingIpList) {
            if (this.floatingIpList[i].id === id) {
              have = true
              break
            }
          }
          if (!have) {
            this.$Notice.error({ title: '未找到此浮动IP' })
            this.error = true
          } else {
            this.floatingIpCanChange = false
          }
        }
        this.floatingIpGetting = false
      }).catch(res => {
        this.error = true
        this.floatingIpGetting = false
      })
    },
    // 获取实例列表
    getServerList (id) {
      this.serverGetting = true
      let params = {
        project_id: this.$store.state.privateCloud.selPrivateCloudProject
      }
      getPrivateCloudAllServer(params).then(res => {
        this.serverList = res.data
        if (id) {
          let have = false
          this.bindForm.server = id
          for (let i in this.serverList) {
            if (this.serverList[i].id === id) {
              have = true
              break
            }
          }
          if (!have) {
            this.$Notice.error({ title: '未找到此实例' })
            this.error = true
          } else {
            this.getPortList(id)
            this.serverCanChange = false
          }
        }
        this.serverGetting = false
      }).catch(res => {
        this.error = true
        this.serverGetting = false
      })
    },
    // 获取根据实例ID获取端口列表
    getPortList (serverId) {
      this.bindForm.port = ''
      this.bindForm.fixed_ip_address = ''
      this.portList = []
      this.fixedIpList = []
      if (serverId) {
        getPrivateCloudAllPort({ device_id: serverId }).then(res => {
          this.portList = res.data
        })
      }
    },
    // 根据端口获取端口的固定IP
    getFixedIpList (portId) {
      this.bindForm.fixed_ip_address = ''
      this.fixedIpList = []
      if (portId) {
        detailPrivateCloudPort(portId).then(res => {
          this.fixedIpList = res.data.port.fixed_ips
        }).catch(res => {
          this.$Notice.error({ title: '获取端口的固定IP失败' })
        })
      }
    },
    // 提交绑定
    submit () {
      this.$refs['bindForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            port_id: this.bindForm.port_id
          }
          if (this.bindForm.fixed_ip_address) {
            reqData.fixed_ip_address = this.bindForm.fixed_ip_address
          }
          this.submitting = true
          changePrivateCloudFloatingIp(reqData, this.bindForm.floatingip_id).then(res => {
            this.errorMsgShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$emit('bindComplete')
            this.$refs.bindForm.resetFields()
            this.submitting = false
            this.bindModal = false
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        }
      }).catch(res => {
        this.$Notice.warning({
          title: '提交失败，请检查表单！'
        })
      })
    },
    // 解除绑定
    unBind (floatingipId) {
      let reqData = {
        port_id: null
      }
      changePrivateCloudFloatingIp(reqData, floatingipId).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.$emit('bindComplete')
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
